// @ts-nocheck
/* eslint-disable */
import Lookup from "./lookup";
import { CHEVRON_LEFT_16, SHARE_FILLED_16, FOLDER_ADD_OUTLINE_16, OVERFLOW_MENU_VERTICAL_FILLED, CLOSE_16, STAR_OUTLINE_24 } from "@sznds/icons";
import HeroHeader from "~/ui/heroheader";
import createSDSIcon from "~/ui/icon";
import createHeaderButton from "~/ui/headerbutton";
import { addListener, makeEvent } from "~/lib/signals";
import { store } from "~/state/store";
import { CONFIG } from "~/config";
import { exportMultiroute } from "./exportmultiroute";
import PlacesItem from "~/places/item";
import { getImageData } from "~/places/imageData";
import { registerUser } from "~/login";
import GPXImport from '~/gpx/import';
import { _ } from "~/i18n";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import MyMapsShare from "~/es6/mymaps.share";
import Scene from "~/scene";
import { buildSortSelectBox, DRAG_AND_DROP_TYPE_ENABLE } from "~/ui/mymaps/sort";
import { isDetailActive } from "~/util/detail";
import { unsetDetail } from "~/state/detail/state";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { description, getIcon } from "~/util/providers/poiagg";
import MyMapsMapyBoxItem from "~/ui/dialogs/mymaps-mapybox-item";
import { getCreateLikeData, getMapyboxExcError, getMapyboxItemAnalyticsType, getMapyboxItemDesc, mapyboxAnalyticsSave } from "~/util/mapybox";
import { getFolderData, setMultipleVisited, likeUpdate } from "~/util/providers/mapybox";
import MyMapsMoveItems from "~/ui/dialogs/mymaps-move-items";
import Dialog from "~/ui/dialog";
import { setCoordinates } from "~/state/map/state";
import { mymapsSetOpenedFolder, mymapsSetAlwaysOnMapFoldersCount } from "~/state/mymaps/state";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { createUserNote } from "~/ui/user-note/note";
import { icon, node, fragment, createPremiumIcon } from "~/util/dom";
import { timeWithUserSpeed } from "~/util/user-speed";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import { ROUTE_CONST } from "~/route/const";
import MyMapsCreateFolder from "~/ui/dialogs/mymaps-create-folder";
import MyMapsBox from "~/ui/mymaps/box";
import MyMapsRemove from "~/ui/dialogs/mymaps-remove";
import { getIcon as contextmenuGetIcon, getTitle as contextmenuGetTitle } from "~/es6/mymaps.contextmenu";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import MyMapsDuplicateFolder from "~/ui/dialogs/mymaps-duplicate-folder";
import MyMapsLinkActivity from "~/ui/dialogs/mymaps-link-activity";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { MYMAPS_DELETE, MYMAPS_EXPORT, MYMAPS_FOLDER_MOVE, MYMAPS_PUBLIC, MYMAPS_SHARE, MYMAPS_STAR_EMPTY } from "~/ui/sds-compatible-icons";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "~/ui/tooltip";
import MyMapsEditActivity from "~/ui/dialogs/mymaps-edit-activity";
import { IMapyBoxItem } from "~/interfaces";
import MyMapsVisited from "~/ui/mymaps/visited";
import MyMapsFilter from "~/ui/mymaps/filter";
import ContextMenu from "~/ui/contextmenu";
import ContextMenuItem from "~/ui/contextmenuitem";
import { VISIBILITY_24, VISIBILITY_OFF_24 } from "~/util/sds-compatible-icons";
import { openPropositionDialog } from "~/util/premium";
import { hidePopup, popupMM } from "~/wasm/controller/util";

/**
 * Hlavni trida pro zobrazeni seznamu mist + vsechny veci okolo.
 *
 * signaly:
 * multiple-mode-open
 * multiple-mode-close
 */
export default class List {
	_multipleVisited: null | MyMapsVisited;

	_loadedItems: number;

	_filter: null | MyMapsFilter;

	_sort: ReturnType<typeof buildSortSelectBox>;

	_dom: {
		container: HTMLDivElement;
		sortArea: HTMLDivElement;
		emptyFilterInfo: HTMLParagraphElement;
	};

	_lookup: Lookup;

	constructor (opts) {
		this._opts = Object.assign({
			isDetail: false, // jedna se o zobrazeni pro detail?
			layer: null, // vrstva pro markery
			cb: null // callback
		}, opts);
		this._folderId = "0"; // id slozky, def "0" pro root, jinak se jedna o detail slozky
		this._actualOffset = 0;
		this._logger = Mapy.getComponent("logger");
		this._dom = {
			container: node("div", { className: "places-list places-list2" }),
			loader: null,
			sortArea: node("div", { className: "sort-area" }),
			emptyFilterInfo: node("p", { className: "empty-filter-info", innerHTML: _("mymap.filters.noResults.places", {
				br: "<br/>",
			})}),
		};
		this._dom.container.setAttribute("x-ms-format-detection", "none");

		this._itemsCache = { cache: {}, toGet: {} };

		this._detailMapping = null;
		this._foldersMapping = [];
		this._itemsMapping = [];
		this._multipleMode = false;
		this._markers = [];
		this._lastAddPopupItem = null;
		this._activeDetail = false;
		this._text = null;
		this._userNote = null;
		this._active = false;
		this._freeLayer = null;
		this._folderBBox = [];
		this._itemsCount = 0;
		this._checkedAll = false;
		this._loadFolderItems = false;
		this._loadNextPageLock = false;
		this._loadedItems = 0;
		this._filter = null;

		this._lookup = new Lookup(this, () => this._filter?.placesFilter || null);
		this._sort = buildSortSelectBox({
			sortType: "custom",
			onChange: value => {
				this._loadFolderItems = false;
				this._cleanLists();

				// loading
				this._appendLoader();

				Mapy.ProviderMapyBox.folderSort(this._folderId, value).then(() => {
					this._setDragAndDrop(false);
					this.load();
					this._logger.log("click", { text: "placesSortingSelect", origin: this._detailMapping?.data?.type ? this._detailMapping?.data?.type : "root", value });
				}, error => {
					// eslint-disable-next-line no-console
					console.error(error);

					if (Mapy.getComponent("places").isActive) {
						this._error(_("mymap.places.sort.error"));
					}
				});
			},
		});

		this._create();

		// drag & drop
		this._sortableFolders = new Mapy.Sortable(this._dom.foldersList);
		this._dom.foldersList.addEventListener("sortable-end", this);
		this._dom.foldersList.addEventListener("sortable-click", this);

		this._sortableItems = new Mapy.Sortable(this._dom.itemsList);
		this._dom.itemsList.addEventListener("sortable-end", this);
		this._dom.itemsList.addEventListener("sortable-click", this);

		this._resize();

		addListener(this, "homeAndWork-highlight", (data) => {
			this.highlightMarker(data.data && Object.keys(data.data).length ? data.data : null);
		});

		// aktivace/deaktivace rucniho mereni a vlastnich bodu
		addListener(this, "distancemeter-activated", () => {
			this._disableInteraction();
		});

		addListener(this, "usermarks-activated", () => {
			this._disableInteraction();
		});

		addListener(this, "path-activated", () => {
			this._disableInteraction();
		});

		addListener(this, "gpx-activated", () => {
			this._lookup?.stop();
		});

		addListener(this, "distancemeter-deactivated", () => {
			this._lookup?.hideGeometry();
			this._lookup?.hideMarker();
			this._enableInteraction();
		});

		addListener(this, "usermarks-deactivated", () => {
			this._lookup?.hideMarker();
			this._enableInteraction();
		});

		addListener(this, "path-deactivated", () => {
			this._lookup?.hideMarker();
			this._enableInteraction();
		});

		addListener(this, "gpx-deactivated", () => {
			this._active && this._lookup?.start();
		});

		addListener(this, "distacemeter-clear", () => {
			this._lookup?.hideMarker();
		});

		addListener(this, "usermarks-clear", () => {
			this._lookup?.hideMarker();
		});

		addListener(this, "print-page", () => this._printPage());
		addListener(this, "print-done", () => this._printDone());

		addListener(this, "gps-format-changed", () => {
			this._itemsMapping.forEach(i => {
				if (i.data.type == "point") {
					let coords = Scene.coordsFromWGS84(i.data.mark.lon, i.data.mark.lat);
					i.data.desc = Mapy.getComponent("gps").coordsToFormat(coords);
					i.elData.desc.textContent = i.data.desc;
				}
			});
		});

		Scene.addListener("provider-changed", function(event) {
			var data = event.data;

			if (Mapy.getComponent("places").isActive && data.name == "m3d") {
				this._show3dRoutes();
			}
		}, this);
	}

	/**
	 * Ziskani obalu.
	 *
	 * @return {Element}
	 */
	getContainer () {
		return this._dom.container;
	}

	/**
	 * Nastaveni drag & drop nad listy.
	 * Pokud je mensi sirka obrazovky nez konstanta, automaticky zakazujeme.
	 *
	 * @return {Element}
	 */
	_setDragAndDrop (state) {
		this._sortableFolders.enabled = state;
		this._sortableItems.enabled = state;
		this._dom.container.classList[state ? "remove" : "add"]("no-drag-drop");
	}

	/**
	 * Nastaveni folder id.
	 *
	 * @param {String} [folderId] ID
	 */
	setFolderId (folderId = "0") {
		if (typeof folderId === "string") {
			this._folderId = folderId;
			this._lookup.folderId = folderId;
			store.dispatch(mymapsSetOpenedFolder(folderId));
		}
	}

	get lookup() {
		return this._lookup;
	}

	get sortType() {
		return this._sort.getValue();
	}

	get listHeader() {
		return this._dom.listHeader;
	}

	/**
	 * Nastaveni folder title.
	 *
	 * @param {String} folderTitle Nazev
	 */
	setFolderTitle (folderTitle) {
		if (typeof folderTitle === "string" && this._opts.isDetail) {
			this._dom.folderName.textContent = folderTitle;
			this._header.title = folderTitle;
		}
	}

	setFolderTotalInfo (totalLength, totalTime) {
		if (typeof totalLength === "number" && typeof totalTime === "number" && totalLength > 0 && totalTime > 0 && this._opts.isDetail) {
			this._header.totalInfoHTML = `<span>${standardDistanceFormat(totalLength).string} • ${standardTimeFormat(totalTime).string}</span> ${_("mymap.places.folderStats")}`;
		} else {
			this._header.totalInfoHTML = "";
		}
	}

	/**
	 * Aktivace komponenty detailu.
	 *
	 * @param  {Boolean} state Stav
	 */
	activeDetail (state) {
		const { data } = store.getState().detail;

		this._activeDetail = state;
		this._lookup.activeDetail(state, data);

		if (this._activeDetail) {
			this._disableInteraction();
		}
		else {
			this._enableInteraction();
		}
	}

	/**
	 * Nacteni a zobrazeni seznamu.
	 *
	 * @return {Promise}
	 */
	load(data) {
		return new Promise((resolve, reject) => {
			this._cleanLists();

			// loading
			this._appendLoader();

			// detail - placeholder pro obrazek
			if (this._opts.isDetail) {
				this._dom.headSection.classList.remove("detail-error");
				this._dom.folderImage.src = List.PLACEHOLDER_URL;

				if (this._header) {
					this._header.poster = "/img/header-placeholder.svg";
				}
			}

			Mapy.getComponent("loader").start(true);

			let prm = Promise.resolve(data);

			if (!data) {
				prm = Mapy.ProviderMapyBox.folderList(this._folderId, undefined, {
					...this._actualOffset > 0 ? { skipCache: true } : {},
				});
			}

			this._removeFreeLayers();

			prm.then(data => {
				this._removeLoader();
				Mapy.getComponent("loader").end(true);

				if (this._opts.isDetail && "type" in data.folder && data.folder.type == "root") {
					Mapy.getComponent("places").state = { data };
					return Promise.resolve();
				}

				// slozka z backendu
				let folder = {
					id: "",
					title: "",
					foreign: false,
					items: [],
					sort_type: "custom",
					...data.folder,
				};

				this._loadedItems = data.folder.items.length;
				this._actualOffset = "nextOffset" in data ? data.nextOffset : data.folder?.items?.length;
				this._itemsCount = folder.itemsCount || 0;
				this._folderBBox = folder.bbox;
				this._sort.setValue(folder.sort_type);

				this._setLoadFolderItems();

				Mapy.getComponent("places").isPublic = false;

				if (Mapy.getComponent("places").isActive) {
					const isUserPremium = isPremiumNoteUser();

					// data z root slozky
					this._itemsCache.toGet = [];
					this._detailMapping = this._createItemFromData(folder, true, isUserPremium);
					// resety drag & drop
					this._cleanLists();
					this._setHeights();
					this._foldersMapping.length = 0;
					this._itemsMapping.length = 0;

					// nastaveni veci pro detail
					if (this._opts.isDetail) {
						this._dom.folderName.textContent = this._detailMapping.data.title;
						this._dom.folderName.title = this._dom.folderName.textContent;

						if (this._header) {
							this._header.title = this._detailMapping.data.title;

							// podle foreign upravim tlacitko zpet
							if (this._dom.backBtn) {
								this._dom.backBtn.removeEventListener("click", this);
								const backBtn = createHeaderButton(this._detailMapping?.data?.foreign === false ? {
									icon: CHEVRON_LEFT_16,
									innerHTML: _("back"),
								} : {
									icon: CLOSE_16,
									innerHTML: _("close"),
								});
								backBtn.addEventListener("click", this);
								this._dom.backBtn.parentNode.replaceChild(backBtn, this._dom.backBtn);
								this._dom.backBtn = backBtn;
							}
						}

						this.setFolderTotalInfo(this._detailMapping.data.totalLength, this._detailMapping.data.totalTime);

						this._dom.headSection.classList[this._detailMapping.data.foreign ? "add" : "remove"]("foreign");

						this._header.rightButtons.innerHTML = "";

						if (this._detailMapping.data.foreign) {
							const saveButton = createHeaderButton({
								icon: MYMAPS_STAR_EMPTY,
								className: "save-star-icon",
								innerHTML: _("save"),
							});
							this._header.rightButtons.appendChild(saveButton);
							saveButton.addEventListener("click", this);
							saveButton.setAttribute("data-log-ignore", "1");
							this._dom.favouriteFolder = saveButton;

							const exportBtn = createHeaderButton({
								icon: MYMAPS_EXPORT,
								className: "export-icon",
							});
							this._header.rightButtons.appendChild(exportBtn);
							exportBtn.setAttribute("data-log-ignore", "1");
							exportBtn.addEventListener("click", () => {
								exportMultiroute(this._detailMapping.data);
							});
						} else {
							const shareButton = createHeaderButton({
								icon: MYMAPS_SHARE,
								innerHTML: _("mymap.contextMenu.share"),
							});
							this._header.rightButtons.appendChild(shareButton);
							shareButton.addEventListener("click", this);
							shareButton.setAttribute("data-log-ignore", "1");
							this._dom.shareCoverBtn = shareButton;

							const menuButton = createHeaderButton({
								icon: OVERFLOW_MENU_VERTICAL_FILLED,
								className: "more-options",
							});
							this._header.rightButtons.appendChild(menuButton);
							menuButton.addEventListener("click", this);
							this._dom.detailOpts = menuButton;
						}

						// obrazek
						if (this._detailMapping.data.img) {
							this._dom.folderImage.src = Mapy.CDN.setSize(this._detailMapping.data.img, Mapy.CDN.SIZE_400_225);

							if (this._header) {
								this._header.poster = Mapy.CDN.setSize(this._detailMapping.data.img, Mapy.CDN.SIZE_400_225);
							}
						}

						if (this._text) {
							this._text.destroy();
						}

						if (this._userNote) {
							this._userNote.destroy();
							this._userNote = null;
						}

						this._clearFilter();

						if (this._detailMapping.data.foreign) {
							// sdili
							const para = createMyMapsSharing({
								data: this._detailMapping.data,
							});

							this._dom.detailCont.after(para);

							if (this._detailMapping.data.description) {
								this._userNote = createUserNote({
									data: this._detailMapping.data,
									foreign: true,
								});

								para.after(this._userNote.container);
							}

							this._text = {
								destroy: () => {
									para.remove();
									this._userNote?.destroy();
									this._userNote = null;
								},
							};
						} else {
							// poznamka
							this._text = new MyMapsBox({
								isPremiumUser: isPremiumNoteUser(),
								noteVersion: getNoteVersion(),
								data: this._detailMapping.data,
							});

							this._header.node.after(this._text.container);
						}

						// nechceme uvnitr detailu slozky videt dalsi slozky
						folder.items = folder.items.filter(i => i.type != "folder");

						Mapy.getComponent("places").isPublic = this._detailMapping.data.public;
					}

					const { user } = store.getState().user;

					if (user.state === "green" && !this._detailMapping.data.foreign && this._itemsCount > 0) {
						this._dom.sortArea.innerHTML = "";
						this._dom.sortArea.append(this._sort.container);
						this._dom.headSection.append(this._dom.sortArea);

						this._createFilter(data.folder);

						if (this._opts.isDetail) {
							this._dom.headSection.append(this._filter.container);
							this._dom.sortArea.append(this._filter.resetCont);
						} else {
							this._dom.filtersArea.append(this._dom.filtersAreaReset);
							this._dom.filtersArea.append(this._filter.container);
							this._dom.filtersAreaReset.append(this._filter.resetCont);
						}
					}

					this.setFolderId(folder.id);
					this._lookup.showLabel = this._opts.owner.showLabel;
					this._error("");
					this._setDragAndDrop((!this._detailMapping.data.foreign || folder.type == "root") && folder.sort_type === DRAG_AND_DROP_TYPE_ENABLE);

					// naplnime seznamy
					this._itemsCache.toGet = [];
					folder.items.forEach(data => {
						this._createItemFromData(data, false, isUserPremium);
					});
					this._updateCacheWithDescription();

					let folderFrag = document.createDocumentFragment();
					this._foldersMapping.forEach(item => folderFrag.appendChild(item.el));
					this._dom.foldersList.appendChild(folderFrag);

					this._updateScrollUIElems();

					let itemFrag = document.createDocumentFragment();
					this._itemsMapping.forEach(item => itemFrag.appendChild(item.el));
					this._dom.itemsList.appendChild(itemFrag);

					// byly nejake polozky
					let count = this._foldersMapping.length + this._itemsMapping.length;
					Mapy.createListStyles(Math.max(this._foldersMapping.length, this._itemsMapping.length));

					if (count) {
						// nastavime drag & drop
						this._setHeights();
					}

					this._setMarkers();
					this._dom.emptyLists.classList[!count ? "remove" : "add"]("hide");
					Mapy.getComponent("mymaps").getContainer().classList[!count ? "add" : "remove"]("empty");

					// je aktivni detail? zkusime, jestli neupravit markery
					if (isDetailActive(store.getState())) {
						this.activeDetail(true);
					}

					// seo
					this.setSEO();
					// 3d zobrazeni
					this._show3dRoutes();

					this._checkLoadNext();

					resolve({
						foreign: this._detailMapping.data.foreign,
						folder: this._detailMapping.data.folder
					});
				} else {
					reject(data);
				}
			}, e => {
				this._removeLoader();
				Mapy.getComponent("loader").end(true);

				if (Mapy.getComponent("places").isActive) {
					// pro detail spesl
					if (this._opts.isDetail) {
						this._dom.headSection.classList.add("detail-error");
						this._dom.error.innerHTML = _("mymap.places.errorDetail");

						const { user } = store.getState().user;

						if (user.state === "green") {
							this._dom.error.insertAdjacentHTML("beforeend", _("mymap.places.errorDetailLink"));
						} else {
							this._dom.error.insertAdjacentHTML("beforeend", _("mymap.places.errorDetailNotLogged"));
						}
					}
					else {
						this._error(_("mymap.places.errorNoList"));
					}
				}

				reject(e);
			});
		});
	}

	_loadNextPage(fromFilter = false) {
		this._loadNextPageLock = true;

		if (!fromFilter && (this._foldersMapping.length + this._itemsMapping.length >= this._itemsCount)) {
			this._loadNextPageLock = false;

			return Promise.reject();
		}

		Mapy.getComponent("loader").start(true);
		this._dom.container.appendChild(Mapy.getComponent("loader").getBigCon());
		const curFilters = this._filter?.changed
			? this._filter.placesFilter
			: null;
		let prm = Mapy.ProviderMapyBox.folderList(this._folderId, undefined, {
			offset: this._actualOffset,
			skipCache: true,
			...curFilters
				? {
					filters: curFilters
				}
				: {},
		});
		return prm.then(data => {
			if (fromFilter) {
				this._itemsCount = this._foldersMapping.length + data.count;
			}

			Mapy.getComponent("loader").end();
			Mapy.getComponent("loader").getBigCon().remove();
			const isUserPremium = isPremiumNoteUser();

			this._itemsCache.toGet = [];
			data.folder.items.forEach(data => {
				this._createItemFromData(data, false, isUserPremium);
			});
			this._updateCacheWithDescription();

			let folderFrag = document.createDocumentFragment();
			this._foldersMapping.forEach(item => folderFrag.appendChild(item.el));
			this._dom.foldersList.appendChild(folderFrag);

			let itemFrag = document.createDocumentFragment();
			this._itemsMapping.forEach(item => itemFrag.appendChild(item.el));
			/*let draggedItem = this._dom.itemsList.querySelector(".dragged");
			if (draggedItem) {
				draggedItem.after(itemFrag);
			}
			else {*/
				this._dom.itemsList.appendChild(itemFrag);
			//}

			if (data.folder.items.length === 0 && this._filter?.changed && this._itemsMapping.length === 0) {
				this._dom.container.append(this._dom.emptyFilterInfo);
			}

			this._updateScrollUIElems();

			// byly nejake polozky
			let count = this._foldersMapping.length + this._itemsMapping.length;
			Mapy.createListStyles(Math.max(this._foldersMapping.length, this._itemsMapping.length));

			if (count || this._filter?.changed) {
				// nastavime drag & drop
				this._setHeights();

				this._sortableFolders.reConf();
				//this._sortableItems.enabled = false;
				this._sortableItems.reConf();
			}

			//vsechny itemy
			this._actualOffset = "nextOffset" in data ? data.nextOffset : count;
			this._loadedItems += data.folder.items.length;
			this._setLoadFolderItems();
			this._loadNextPageLock = false;
			this._updateSelectCount();
			this._updateVisited();

			return data;
		}, () => {
			this._loadNextPageLock = false;
		});
	}

	_updateScrollUIElems() {
		this._dom.itemsSeparator.classList[!this._opts.isDetail && this._itemsMapping.length > 0 ? "remove" : "add"]("empty");
		this._dom.filtersArea.classList[(!this._opts.isDetail && this._itemsMapping.length) || this._filter?.changed > 0 ? "remove" : "add"]("empty");
	}

	_applyFilter() {
		for (const item of this._itemsMapping) {
			item.el.remove();
		}

		this._dom.itemsList.innerHTML = "";
		this._itemsMapping.length = 0;
		// smazeme polozky - ne slozky
		const offset = this._foldersMapping.length;

		this._loadedItems = offset;
		this._actualOffset = offset;
		this._itemsCount = offset;
		this._dom.emptyFilterInfo.remove();
		this._loadNextPage(true);
		this._lookup?.lookup();
	}

	_createFilter(filterData) {
		const origin = this._opts.isDetail
			? "folder"
			: "root";

		this._filter = new MyMapsFilter({
			filterData,
			isPremiumUser: isPremiumNoteUser(),
			onReset: () => {
				this._applyFilter();
				Mapy.getComponent("logger").log("my_maps_reset_filter", {
					origin,
				});
			},
			onChange: () => {
				this._applyFilter();
			},
			onAnalytics: type => {
				Mapy.getComponent("logger").log("my_maps_set_filter", {
					origin: "aktivity",
					type,
				});
			},
		});
	}

	_clearFilter() {
		if (this._filter) {
			this._filter.destroy();
			this._filter.container.remove();
			this._filter.resetCont.remove();
			this._filter = null;
		}

		this._dom.filtersArea.innerHTML = "";
	}

	/**
	 * Vycisteni dat.
	 */
	clean () {
		this._foldersMapping.length = 0;
		this._itemsMapping.length = 0;
		this._loadedItems = 0;
		this._loadFolderItems = false;
		this._cleanLists();
		this._setHeights();
		this._removeFreeLayers();
		this._updateScrollUIElems();
		this._clearFilter();

		if (this._multipleMode) {
			this.setMultipleMode(false);
		}

		this._error("");

		// smazeme predesle
		while (this._markers.length) {
			this._markers.pop();
		}

		if (this._opts.layer) {
			this._opts.layer.removeAll();
		}

		this._lookup.clean();
	}

	/**
	 * Vloží home and work sekci na správné místo
	 * @param {HTMLElement} container kontejner s home and work
	 */
	addHomeWork (container) {
		this._dom.homework = container;
		this._dom.headSection.firstChild ? this._dom.headSection.firstChild.before(this._dom.homework) : this._dom.headSection.appendChild(this._dom.homework);
	}

	/**
	 * Odstraní sekci Home and work z domu
	 */
	removeHomeWork () {
		this._dom.homework.remove();
	}

	// type: item, track
	loadItemDetail (id, type = "item", replace = false) {
		let trackDetail = type == "track";

		// nacteme data pro detail - nemelo by chodit ve folder listu
		if (id && typeof id === "string") {
			let detailProm = trackDetail ? Mapy.ProviderMapyBox.trackDetail(id).promise : Mapy.ProviderMapyBox.likeDetail(id);

			detailProm.then(data => {
				if (Mapy.getComponent("places").isActive) {
					this._openDetailRequest(trackDetail ? data.track : data.like || { type: "" }, replace);
				}
			}, e => {
				// eslint-disable-next-line no-console
				console.error(e);
				if (Mapy.getComponent("places").isActive) {
					this._notification(_("mymap.places.errorDetailNotification"), true);
				}
			});
		}
	}

	/**
	 * Podbarveni itemu.
	 *
	 * @param  {Object} [item] Item z mapping, kdyz neni, tak jsou vsechny aktivni
	 */
	highlightItem (item, fromLookup) {
		this._itemsMapping.forEach(i => {
			if (fromLookup) {
				i.el.classList[item && i.data.id == item.id ? "add" : "remove"]("active");
			}
			else {
				i.el.classList[item && i == item ? "add" : "remove"]("active");
			}
		});
	}

	/**
	 * Podbarveni markeru.
	 *
	 * @param  {Object} [item] Item z mapping, kdyz neni, tak jsou vsechny aktivni
	 */
	highlightMarker(item, fromGeometry) {
		let markers = this._opts.layer?.getMarkers() || [];

		markers.forEach(marker => {
			if (!item || (item && item.marker == marker)) {
				marker.setActive(true);
				marker.setFocus(true);
			}
			else {
				marker.setActive();
				marker.setFocus();
			}
		});

		!fromGeometry && this._lookup.highlight(item?.data ? item.data : item?.marker ? { id: "homework" } : null);
	}

	highlightById(dim: string) {
		let item = this._itemsMapping.find(i => i.data.id === dim);

		if (dim && !item) {
			this._lookup.tryHighlight(dim);

			return;
		}

		if (item) {
			this.highlightItem(item);
			this.highlightMarker(item);
		} else {
			this.highlightItem();
			this.highlightMarker();
		}
	}

	get shareData () {
		return this._detailMapping.data;
	}

	handleEvent (e) {
		switch (e.type) {
			case "resize":
				this._resize();
				break;

			case "click":
				if (this._dom.detailOpts && this._dom.detailOpts.contains(e.target)) {
					e.stopPropagation();
					if (this._detailMapping.contextMenu?.isOpen) {
						this._detailMapping.contextMenu.close();
						this._detailMapping.contextMenu.destroy();
						this._detailMapping.contextMenu = null;
					} else {
						this._readyContextMenu(this._detailMapping, true, this._dom.detailOpts);
						this._detailMapping.contextMenu.open();
					}
				} else if (e.target.classList.contains("error-home-mymaps")) {
					e.preventDefault();
					Mapy.getComponent("places").state = {
						mid: "",
						goBack: true,
						folderTitle: "",
						keepData: false
					};
					Mapy.getComponent("history").save();
				} else if (e.target.classList.contains("error-login")) {
					e.preventDefault();
					Mapy.getComponent("login").open({
						motivation: "none",
					});
				} else if (e.target.classList.contains("error-register")) {
					e.preventDefault();
					registerUser();
				} else if (this._dom.makeFolderBtn.contains(e.target)) {
					new MyMapsCreateFolder({
						isPremiumUser: isPremiumNoteUser(),
						noteVersion: getNoteVersion(),
						onSave: () => {
							this._loadWithDelete();
							this.zoomToItems();
						},
					}).open();
				} else if (this._dom.importGPX.contains(e.target)) {
					GPXImport.open({
						logType: "myMaps"
					});
				} else if (this._dom.cancelBtn.contains(e.target)) {
					this.setMultipleMode(false);
					Mapy.getComponent("places").detailLock = false;
				} else if (this._dom.shareCoverBtn && this._dom.shareCoverBtn.contains(e.target)) {
					const { mapset, provider } = store.getState().map;

					let sharePopup = new MyMapsShare(Object.assign({}, this._detailMapping.data, {
						like: true,
						customCloseLog: true,
						url: `${location.protocol}//${location.host}/${mapset}?moje-mapy&cat=mista-trasy&mid=${this._detailMapping.data.id}${provider === "m3d" ? "&m3d=1" : ""}`,
						showLabel: true
					}), cbData => {
						if (cbData.name == "popup-close") {
							if (this._detailMapping.data.public != cbData.public) {
								this._detailMapping.data.public = cbData.public;
								if (this._detailMapping.isFolder) {
									this._itemsMapping.forEach(dataItem => {
										dataItem.data.public = cbData.public;
										dataItem.el.classList[cbData.public ? "add" : "remove"]("public");
									});
								}
								Mapy.getComponent("places").listRefreshData();
							}
						}
					});
					sharePopup.open();
				} else if (this._dom.favouriteFolder && this._dom.favouriteFolder.contains(e.target)) {
					this._logger.log("click", {
						text: "uložit_hvězda",
						type: "folder"
					});

					this._starClick(this._detailMapping);
				} else if (this._dom.backBtn && this._dom.backBtn.contains(e.target)) {
					// koukame na vlastni? nesmi byt undefined nebo null, ale fakt false
					if (this._detailMapping?.data?.foreign === false) {
						Mapy.getComponent("places").state = {
							mid: "",
							goBack: true,
							folderTitle: "",
							keepData: true,
							childFolderDelete: true,
						};
						Mapy.getComponent("mymaps").getContainer().classList.remove("empty");
						Mapy.getComponent("history").save();
					} else {
						Mapy.getComponent("places").state = {
							mid: "",
							goBack: true,
							folderTitle: "",
							keepData: true,
						};
						Mapy.getComponent("search").activate();
						Mapy.getComponent("history").save();
					}
				} else {
					//hromadné operace
					let addToFolder = this._dom.addToFolderBtn.contains(e.target);
					let deleteFolder = this._dom.deleteBtn.contains(e.target);
					Mapy.getComponent("places").detailLock = false;

					if (addToFolder || deleteFolder) {
						let items = this._getSelectedItems().map(item => item.data);

						if (items.length) {
							this._error("");

							const ids = items.map(item => item.id);

							if (deleteFolder) {
								new MyMapsRemove({
									data: this._detailMapping.data,
									ids,
									isMultiple: true,
									onRemove: () => {
										this.setMultipleMode(false);
										this._logger.log(`my_maps_item${items.length > 1 ? "s" : ""}_delete`, { length: items.length, type: (items.length == 1 ? items[0].type : "any") });
										this._loadWithDelete();
									},
								}).open();
							} else {
								this._lastAddPopupItem = items.length
									? items[items.length - 1]
									: null;

								// hromadne operace dialog
								new MyMapsMoveItems({
									ids,
									moveFolders: [{
										id: this._detailMapping.data.id,
										title: this._detailMapping.data.title,
									}],
									isMultiple: true,
									onSave: () => {
										this._moveDone();
									},
								}).open();
							}
						}
					}
				}
				break;

			case "sortable-click":
				let item = this._getItemFromLi(e.target, e.detail.item);

				if (!item) return;

				const opts = e.detail.target.closest(".opts");

				if (opts) {
					if (item.contextMenu?.isOpen) {
						item.contextMenu.close();
						item.contextMenu.destroy();
						item.contextMenu = null;
					} else {
						this._readyContextMenu(item, false, opts);
						item.contextMenu.open();
					}
				} else if (e.detail.target.closest(".public-icon")) {
					this._contextMenuCb("share", item);
				} else if (e.detail.target.closest(".star")) {
					this._starClick(item);
				} else if (!e.detail.target.closest("mapy-checkbox")) {
					if (this._multipleMode) {
						// preskocime click na navstiveno
						if (e.detail.target.closest(".mymapsVisited")) {
							return;
						}

						let cb = item.el.querySelector("mapy-checkbox");

						if (cb) {
							cb.checked = !cb.checked;
						}

						this._updateSelectCount();
					} else {
						item.itemObject?.closeTooltips();

						// otevreme detail
						this._openDetail(item);
					}
				}

				break;

			case "sortable-end":
				// vysledne id ve slozce, nejdrive slozky, pak itemy
				let swap = null;

				if (e.target == this._dom.foldersList) {
					swap = this._foldersMapping.splice(e.detail.fromIndex, 1)[0];
					this._foldersMapping.splice(e.detail.toIndex, 0, swap);

				} else {
					swap = this._itemsMapping.splice(e.detail.fromIndex, 1)[0];
					this._itemsMapping.splice(e.detail.toIndex, 0, swap);
				}

				// seznam id
				let ids = [];

				this._foldersMapping.forEach(i => ids.push(i.data.id));
				this._itemsMapping.forEach(i => ids.push(i.data.id));

				// request
				this._error("");

				Mapy.ProviderMapyBox.folderSort(this._folderId, "custom", ids).then(() => {
					// nemusime nic upravovat
				}, e => {
					// eslint-disable-next-line no-console
					console.error(e);
					if (Mapy.getComponent("places").isActive) {
						this._error(_("mymap.places.errorDragAndDrop"));
					}
				});

				break;

			case "scroll":
				this._scroll();

				break;
		}
	}

	set active (value) {
		this._active = value;

		if (this._active) {
			Mapy.getComponent("layout").getScrollNode().addEventListener("scroll", this, { passive: false });
		} else {
			Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this);
		}

		this._updateMultipleVisited();
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_create () {
		// vytvoreni slozky
		let loaderCont = node("div", { className: "loader-cover" });
		let loader = new Image();
		loader.crossOrigin = "anonymous";
		loader.src = "/img/loader.gif";
		loader.classList.add("loader");

		let listHeader = node("div", { className: "list-header" });
		let headSection = node("div", { className: "head-section" });
		let makeFolderCover = node("div", { className: "make-folder-cover" });
		let makeFolderBtn = node("button", { className: "make-folder-btn" });
		makeFolderBtn.appendChild(createSDSIcon({ symbol: FOLDER_ADD_OUTLINE_16 }));
		makeFolderBtn.appendChild(node("span", { textContent: _("mymap.folders.createFolder") }));
		makeFolderBtn.addEventListener("click", this);
		makeFolderCover.appendChild(makeFolderBtn);
		let importGPX = node("button", { className: "import-gpx-btn" });
		importGPX.appendChild(icon("import2"));
		importGPX.appendChild(node("span", { textContent: _("mymap.contextMenu.import") }));
		importGPX.addEventListener("click", this);
		makeFolderCover.appendChild(importGPX);

		let multipleCover = node("div", { className: "multiple-actions" });

		const multipleTopLine = node("div", { className: "top-line" });
		const multipleControls = node("div", { className: "controls" });
		const controlsLeft = node("div", { className: "controls-left" });
		const controlsRight = node("div", { className: "controls-right" });

		let multipleSwitchCont = node("span", { className: "select-all" });
		let selectCount = node("span", { className: "select-count" });
		let multipleSwitchTitle = node("p", { textContent: _("mymap.places.selectAll") });
		let multipleSwitch = node("mapy-checkbox");
		multipleSwitch.addEventListener("change", e => {
			this._selectAll(e.target.checked);
			multipleSwitchTitle.textContent = e.target.checked
				? _("mymap.places.chooseNothing")
				: _("mymap.places.selectAll");
		});

		/* eslint-disable-next-line */
		new Tooltip({
			anchor: multipleSwitchCont,
			trigger: multipleSwitchCont,
			triggerEventType: "pointerenter",
			content: multipleSwitchTitle,
			arrow: false,
			flow: ETooltipFlow.CENTER,
			position: ETooltipPosition.TOP,
			offset: [2, 0, 0, 0],
		});

		const addToFolderBtn = node("button", { className: "add-to-folder" });
		const addToFolderTitle = node("span", { textContent: _("move") });

		addToFolderBtn.append(createSDSIcon({ symbol: MYMAPS_FOLDER_MOVE }), addToFolderTitle);

		const deleteBtn = node("button", { className: "delete" });
		const deleteTitle = node("span", { textContent: _("delete") });

		deleteBtn.append(createSDSIcon({ symbol: MYMAPS_DELETE }), deleteTitle);

		let cancelBtn = node("mapy-router-button", {}, _("done"));
		cancelBtn.title = _("cancel");

		addToFolderBtn.addEventListener("click", this);
		deleteBtn.addEventListener("click", this);
		cancelBtn.addEventListener("click", this);

		multipleControls.append(controlsLeft, controlsRight);

		multipleCover.append(multipleTopLine, multipleControls);
		multipleTopLine.append(node("h3", { className: "multiple-title", textContent: _("mymap.contextMenu.multiple2") }), cancelBtn);
		multipleSwitchCont.append(multipleSwitch);
		controlsLeft.append(multipleSwitchCont, selectCount, addToFolderBtn, deleteBtn);

		headSection.appendChild(makeFolderCover);
		headSection.appendChild(multipleCover);
		// konec

		let foldersList = node("ul", { className: "folders" });
		let itemsList = node("ul", { className: "items" });
		let emptyLists = node("div", { className: "empty-lists hide" });
		let itemsSeparator = node("div", { className: "items-separator" });
		let filtersArea = node("div", { className: "filters-area" });
		let filtersAreaReset = node("div", { className: "filters-area__reset" });
		let error = node("div", { className: "error" });
		error.addEventListener("click", this, false);

		emptyLists.appendChild(node("p", { className: "title", textContent: _("mymap.places.emptyList2") }));
		emptyLists.appendChild(node("img", { src: "/img/mymap/empty-places.svg" }));
		// konec

		this._dom.container.appendChild(listHeader);
		listHeader.appendChild(headSection);
		this._dom.container.appendChild(loaderCont);
		this._dom.container.appendChild(foldersList);
		this._dom.container.appendChild(itemsSeparator);
		this._dom.container.appendChild(filtersArea);
		this._dom.container.appendChild(itemsList);
		this._dom.container.appendChild(emptyLists);

		loaderCont.appendChild(error);

		// dom bind
		Object.assign(this._dom, {
			importGPX, loader, loaderCont, headSection, foldersList, itemsList, makeFolderBtn, emptyLists, makeFolderCover, error, addToFolderBtn, deleteBtn,
			cancelBtn, multipleCover, multipleSwitch, itemsSeparator, listHeader, selectCount, controlsRight, filtersArea, filtersAreaReset,
		});

		if (this._opts.isDetail) {
			this._createDetail();
		}
	}

	/**
	 * Vytvoreni nove polozky z dat.
	 *
	 * @param  {Object}  data Data z backendu
	 * @param  {Boolean} [isRoot] Root slozka
	 * @return {Object}
	 */
	_createItemFromData (data, isRoot, isPremium) {
		let newItem = {
			isRoot,
			isFolder: isRoot || data.type == "folder",
			imageData: isRoot ? null : getImageData(data),
			star: false,
			data,
			marker: null,
			parent: null,
			parentId: data.parent_id || null,
			contextMenu: null,
			itemObject: null,
			isPremium,
		};

		if (isRoot && this._opts.isDetail) {
			newItem.elData = {
				el: this._dom.folderName,
				title: this._dom.folderName,
				detailCont: this._dom.detailCont
			};
			newItem.el = newItem.elData.el;
			newItem.parent = newItem.elData.detailCont;
		}
		else if (!isRoot && newItem.isFolder) {
			newItem.elData = this._createFolder(newItem, isPremium);
			newItem.el = newItem.elData.el;

			//this._dom.foldersList.appendChild(newItem.el);
			newItem.img = data.img || null;
			this._foldersMapping.push(newItem);
		}
		else if (!isRoot) {
			let type = data.type;

			if (type == "measure" && data.data.readonly) {
				type = "measureRO";
			}

			// uprava dat pro popisek druhe urovne
			switch (type) {
				case "point": {
					let coords = Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
					newItem.data.desc = `${_("detail.content.point")} ${Mapy.getComponent("gps").coordsToFormat(coords)}`;
					break;
				}
				case "entity":
					let cacheName = `${data.source}${data.source_id}`;
					if (this._itemsCache.cache[cacheName] && this._itemsCache.cache[cacheName][0] && "description" in this._itemsCache.cache[cacheName][0]) {
						newItem.data.desc = this._itemsCache.cache[cacheName][0].description || "";
					} else {
						newItem.data.desc = "";

						this._itemsCache.toGet.push({ source: data.source, id: data.source_id, });

						if (!this._itemsCache.cache[cacheName]) {
							this._itemsCache.cache[cacheName] = [];
						}
						this._itemsCache.cache[cacheName].push({
							item: newItem
						});
					}
					break;
				case "route": {
					let distance = standardDistanceFormat(data.data.totalLength);
					let time = standardTimeFormat(timeWithUserSpeed(data.data.totalTime, data.data.route[0].routeParams?.criterion || data.data.route[0].tripParams?.criterion || ROUTE_CONST.types.car.def));
					newItem.data.desc = _("mymap.places.route", { DIST: distance.string, TIME: time.string });
					break;
				}
				case "set": {
					newItem.data.desc = _("userMarks.favouritePoint", {
						NUM: data.data.ut.length || 0,
						TXT: data.data.ut.length || 0
					});
					break;
				}
				case "measure": {
					newItem.data.desc = getMapyboxItemDesc(data);
					break;
				}

				case "measureRO": {
					let coords = Scene.stringToCoords(data.data.points);
					let distances = Mapy.Util.IP.countDistances(coords);
					let distance = standardDistanceFormat(distances.length ? distances[distances.length - 1] : 0);
					newItem.data.desc = `${_("path.title")} ${distance.string}`;
					break;
				}

				case "path": {
					let distance = standardDistanceFormat(data.data.info.totalLength);
					newItem.data.desc = `${_("path.title")} ${distance.string}`;
					break;
				}

				case "link": {
					let distance = standardDistanceFormat(data.data.totalLength);
					let time = standardTimeFormat(data.data.totalTime);
					newItem.data.desc = _("mymap.activity.track", { DIST: distance.string, TIME: time.string });
					break;
				}
				default:
					newItem.data.desc = "";
			}
			newItem.itemObject = this._createItem(newItem, isPremium);
			newItem.elData = newItem.itemObject.data;
			newItem.el = newItem.elData.el;

			// bindujeme eventy, na slozkach je nechceme
			newItem.el.addEventListener("mouseenter", e => {
				//if (this._activeDetail) return;
				if (CONFIG.wasmEnabled) {
					const { markers } = store.getState().mapContent;
					const wasmMarker = markers.find(marker => marker.customData?.dim === newItem.data.id && marker.type === "small");

					wasmMarker && popupMM(wasmMarker, Mapy.getComponent("wasm").wasm);
				}

				this.highlightMarker(newItem);
			});

			newItem.el.addEventListener("mouseleave", e => {
				//if (this._activeDetail) return;
				if (CONFIG.wasmEnabled) {
					hidePopup(true);
				}

				this.highlightMarker();
			});

			//this._dom.itemsList.appendChild(newItem.el);
			this._itemsMapping.push(newItem);
		}

		return newItem;
	}

	/**
	 * Vytvoreni veci specialne pro detail slozky.
	 */
	_createDetail() {
		let detailCont = node("div", { className: "detail-cont" });
		let poster = node("div", { className: "poster" });
		let folderNameCover = node("div", { className: "folder-name-cover" });
		let folderName = node("h2", { className: "folder-name" });
		let shareCover = node("div", { className: "share-save-cover" });
		let favouriteFolder = this._createBtn("favourite-btn", "star-line", _("save"));
		favouriteFolder.setAttribute("data-log-ignore", "1");
		shareCover.appendChild(favouriteFolder);
		let shareCoverBtn = this._createBtn("share-btn", "share", _("share"));
		shareCoverBtn.setAttribute("data-log-ignore", "1");
		let detailOpts = node("span", { className: "opts" });
		detailOpts.appendChild(icon("etc-vertical"));
		shareCover.appendChild(shareCoverBtn);
		folderNameCover.appendChild(folderName);

		let totalInfoCover = node("div", { className: "total-info" });

		const { user } = store.getState().user;
		const logged = user.state === "green";
		let backBtn = this._createBtn("back-btn", logged ? "back" : "close", logged ? _("back") : _("close"));
		backBtn.addEventListener("click", this);
		let folderImage = node("img", { src: List.PLACEHOLDER_URL });
		poster.appendChild(folderImage);

		detailCont.appendChild(poster);
		detailCont.appendChild(detailOpts);
		detailCont.appendChild(folderNameCover);
		detailCont.appendChild(shareCover);
		detailCont.appendChild(totalInfoCover);
		detailCont.appendChild(backBtn);

		this._dom.shareCoverBtn = shareCoverBtn;
		this._dom.detailOpts = detailOpts;
		this._dom.folderName = folderName;
		this._dom.favouriteFolder = favouriteFolder;
		this._dom.folderNameCover = folderNameCover;
		this._dom.totalInfoCover = totalInfoCover;
		this._dom.detailCont = detailCont;
		this._dom.poster = poster;
		this._dom.backBtn = backBtn;
		this._dom.folderImage = folderImage;

		favouriteFolder.addEventListener("click", this);
		detailOpts.addEventListener("click", this);
		shareCoverBtn.addEventListener("click", this);

		// skryjeme vytvorit slozku
		this._dom.makeFolderCover.classList.add("hide");

		this._buildHeader();
	}

	_buildHeader() {
		this._header = new HeroHeader({
			poster: "/img/header-placeholder.svg",
		});
		this._dom.listHeader.firstChild.before(this._header.node);
		this._dom.detailCont = this._header.node;

		const backButton = createHeaderButton({
			icon: CHEVRON_LEFT_16,
			innerHTML: _("mymap.stateswitch"),
		});
		this._header.leftButtons.appendChild(backButton);
		this._dom.backBtn = backButton;
	}

	/**
	 * Vytvoreni tlacitka pro hromadne operace.
	 *
	 * @param  {String} className CSS trida
	 * @param  {String} icon SVG ikona
	 * @param  {String} txt Text
	 * @return {Element}
	 */
	_createBtn(className, buttonIcon, txt) {
		let button = node("button", { className });
		let caption = node("span", { className: "caption", textContent: txt });
		button.appendChild(icon(buttonIcon));
		button.appendChild(caption);
		button.addEventListener("click", this);

		return button;
	}

	/**
	 * Vytvoreni listu pro slozky.
	 */
	_createFolder(dataItem, isPremium) {
		let li = node("li", { className: "folder" });
		// handle pro tahani
		let points = node("span", { className: "points" });
		points.appendChild(icon("move"));
		li.appendChild(points);
		let imageCover = node("div", { className: "image-cover" });

		if (dataItem.imageData.img) {
			imageCover.appendChild(dataItem.imageData.img());
		} else {
			imageCover.classList.add("svg-placeholder");
			imageCover.appendChild(dataItem.imageData.svg());
		}

		// oko pro always on map
		if (isPremium && dataItem.data.always_on_map) {
			imageCover.appendChild(node("img", { src: "/img/mymap/always-on-map-eye.svg", className: "always-on-map" }));
		}

		const iconCover = node("div", { className: "icon-cover" });

		iconCover.append(icon("mymaps-folder"));
		imageCover.append(iconCover);

		let bar = node("div", { className: "bar" });

		if (dataItem.data.public) {
			bar.classList.add("public");
		}

		let title = node("h2", { className: "title overflow-ellipsis", textContent: dataItem.data.title });
		let publicEl = node("span", { className: "public-icon" });
		publicEl.appendChild(createSDSIcon({ className: "icon-public", symbol: MYMAPS_PUBLIC }));
		bar.appendChild(title);
		bar.appendChild(publicEl);
		let opts = node("span", { className: "opts" });
		opts.appendChild(icon("etc-vertical"));
		li.appendChild(imageCover);
		li.appendChild(bar);
		li.appendChild(opts);

		dataItem.parent = li;

		/* eslint-disable-next-line */
		const tooltip = new Tooltip({
			anchor: publicEl,
			trigger: publicEl,
			triggerEventType: "pointerenter",
			content: node("p", { textContent: _("mymap.editSharing") }),
			arrow: false,
			flow: ETooltipFlow.CENTER,
			position: ETooltipPosition.TOP,
			offset: [2, 0, 0, 0],
		});

		return {
			el: li,
			title,
			bar,
			imageCover
		};
	}

	/**
	 * Vytvoreni listu pro itemy.
	 *
	 * @param  {Object} dataItem Data pro jednu polozku
	 * @param  {ContextMenu} contextMenu instance
	 * @return {Object} el a titulek
	 */
	_createItem(dataItem, isPremium) {
		return (new PlacesItem(dataItem, {
			foreign: this._detailMapping.data.foreign,
			checked: this._checkedAll,
			isPremium,
			setCheckedCounter: () => {
				this._updateSelectCount();
			},
		}));
	}

	/**
	 * Callback z context menu.
	 *
	 * @param  {String} type Typ udalosti z contextmenu
	 * @param  {Object} itemData Mapovani dat a callbacku
	 */
	async _contextMenuCb(type, itemData) {
		const data = itemData.data;
		const logData = {
			action: null,
			data: {
				type: data.type
			}
		};

		switch (type) {
			case "share":
				let itemId = data.id;
				const { mapset, provider, zoom } = store.getState().map;
				let itemType = "";

				if (data.linktype) {
					itemType = data.linktype;
				} else {
					itemType = data.type;
				}

				let dataShare = Object.assign({
					url: `${location.protocol}//${location.host}/${mapset}?moje-mapy&cat=mista-trasy&mid=${itemId}${provider === "m3d" ? "&m3d=1" : ""}`,
					like: true
				}, data);

				if (!itemData.isFolder) {
					dataShare.url = `${location.protocol}//${location.host}/${mapset}?dim=${itemId}`

					if (["point", "entity"].indexOf(itemData.data.type) > -1) {
						dataShare.url += `&z=${zoom}`;
					}
				}

				dataShare.showLabel = true;

				let sharePopup = new MyMapsShare(dataShare, cbData => {
					if (cbData.name == "popup-close") {
						data.public = cbData.public;

						// upravime vizual slozky
						if (itemData.isFolder && itemData.elData.bar) {
							itemData.elData.bar.classList[data.public ? "add" : "remove"]("public");
						} else if (itemData.elData.el) {
							itemData.elData.el.classList[data.public ? "add" : "remove"]("public");
						}

						Mapy.getComponent("places").listRefreshData();
					}
				}, data.title + " - " + _("mymap.switcher.saved"));
				sharePopup.open();
				break;

			case "duplicate":
				new MyMapsDuplicateFolder({
					id: data.id,
					parentId: this._opts.isDetail
						? this._detailMapping.data.parent_id
						: this._folderId,
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					onDuplicate: () => {
						this._loadWithDelete();

						if (this._opts.isDetail) {
							Mapy.getComponent("places").listRefreshData();
						}
					},
					alwaysOnMap: !!data.always_on_map,
					title: data.title,
					description: data.description,
				}).open();
				break;

			case "navigate":
				let coords = Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
				let route = Mapy.getComponent("route");

				if (route.isActive()) {
					route.deactivate();
				}

				if (!Mapy.CML.state.route?.items?.length) {
					Mapy.CML.state = {
						route: {
							params: {
								criterion: data.source == "pubt" ? 200 : 111
							}
						}
					}
				}

				await route.addItem({
					coords,
					name: data.title,
					...data.usertitle ? { usertitle: data.usertitle } : {},
					source: data.source || "coor",
					id: data.source_id || coords.toWGS84().join(","),
					favoriteId: data.id,
					desc: data.subtitle && data.subtitle != "" ? data.subtitle : data.desc,
				});

				await route.activate();

				logData.action = "my_maps_item_navigate";
				this._logger.log(logData.action, logData.data);

				Mapy.getComponent("history").save();
				break;

			case "save-as-new":
			case "edit": {
				if (type === "edit" && data.linktype === "track") {
					this._editTrack(data);
				} else {
					new MyMapsMapyBoxItem({
						isPremiumUser: isPremiumNoteUser(),
						noteVersion: getNoteVersion(),
						likeData: data,
						...this._opts.isDetail
							? {
								folder: {
									id: this._detailMapping.data.id,
									title: this._detailMapping.data.title,
								},
							}
							: {},
						mode: type === "edit"
							? "edit"
							: "save-as-new",
						onSave: ({ likeData: editData, trackType }) => {
							if (type === "edit") {
								Object.assign(data, editData);

								if (trackType) {
									if (data.type === "path") {
										data.data.info.trackType = trackType;
									} else if (data.linktype === "track") {
										data.data.type = trackType;
									}
								}
							} else {
								mapyboxAnalyticsSave({
									type: getMapyboxItemAnalyticsType(data),
									note: !!editData.description,
									visited: editData.visited,
								});
							}

							this._moveDone();
							this._lookup.lookup();
						},
					}).open();
				}
				break;
			}

			case "multiple":
				this.setMultipleMode(true);
				break;

			case "download": {
				switch (data.type) {
					case "set":
						new MyMapsExport({
							data: {
								name: "usermarks",
								data: {
									uc: data.data.uc,
									ud: data.data.ud,
									ut: data.data.ut,
									title: data.title,
									subtitle: data.subtitle,
									usertitle: data.usertitle,
								},
							},
							onExport: () => {
								Mapy.getComponent("logger").log("points", { end_points: "download", count: Scene.stringToCoords(data.data.uc).length });
							},
						}).open();
						break;

					case "measure":
						new MyMapsExport({
							data: {
								name: "distancemeter",
								data: {
									criterion: "hand",
									geometry: data.data.points,
									title: data.usertitle || data.title,
								},
							},
							onExport: () => {
								const coords = Scene.stringToCoords(data.data.points);
								const first = coords[0];
								const last = coords[coords.length - 1];
								let distance = 0;

								coords.forEach((item, ind) => {
									if (ind > 0) {
										distance += coords[ind].distance(coords[ind - 1]);
									}
								});

								Mapy.getComponent("logger").log("measure", {
									end_measure: "download",
									count: coords.length - 1,
									fromLat: first[1],
									fromLon: first[0],
									toLat: last[1],
									toLon: last[0],
									length: distance,
								});
							},
						}).open();
						break;

					case "path":
						new MyMapsExport({
							data: {
								name: "path",
								data: {
									mid: data.id,
									title: data.usertitle || data.title,
								},
							},
						}).open();
						break;

					case "route":
						Mapy.PlacesExportRoute(data, itemData.imageData.svgName == "car");
						break;

					default:
						if (itemData.isFolder) {
							this._exportFolder(data);
						} else if (data.linktype === "track") {
							new MyMapsExport({
								data: {
									name: "activity",
									data: {
										mid: data.linkid,
										title: data.usertitle || data.title,
									},
								},
							}).open();
						}
				}
				break;
			}

			case "delete":
			case "delete-from-all":
			case "activity-remove":
			case "remove":
				new MyMapsRemove({
					data,
					operation: type === "delete" || type === "delete-from-all"
						? "delete"
						: "remove",
					onRemove: () => {
						// smazeme root -> jdeme zpet
						if (this._detailMapping.data.id == data.id) {
							Mapy.getComponent("places").state = {
								goBack: true,
								childFolderDelete: true
							};
							Mapy.getComponent("history").save();
						} else {
							this._loadWithDelete();
						}

						logData.action = "my_maps_item_delete";
						this._logger.log(logData.action, logData.data);
					},
				}).open();
				break;

			case "import":
				let folderId = itemData.data.type == "folder" ? itemData.data.id : this._folderId;

				GPXImport.open({
					folderId,
					folderTitle: itemData.data.type == "folder" ? itemData.data.title : this._header.title || "",
					logType: this._opts.isDetail ? "myMapsFolderOpen" : "myMapsFolder"
				});
				break;

			case "activity-move-to-folder":
			case "move-to-folder":
				this._moveItemToFolder(itemData.data);
				break;

			case "link-to-another-folder":
				new MyMapsLinkActivity({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					type: "link-to-another-folder",
					trackData: itemData.data,
				}).open();
				break;

			case "always-on-map":
				const state = store.getState();
				const user = state.user.user;
				const { alwaysOnMapFoldersCount } = state.mymaps;
				const alwaysOnMap = !data.always_on_map;

				if (user.premium) {
					await likeUpdate(data.id, { always_on_map: alwaysOnMap });
					Mapy.getComponent("logger").log("my_maps_item_edit", {
						isAlwaysOnMap: alwaysOnMap ? "1" : "0",
						changed: ["is_always_on_map"],
						origin: "context_menu",
						type: "folder",
					});
					store.dispatch(mymapsSetAlwaysOnMapFoldersCount({
						alwaysOnMapFoldersCount: alwaysOnMap ? alwaysOnMapFoldersCount + 1 : alwaysOnMapFoldersCount - 1,
					}));
					this.load();
					this._lookup.lookup();
				} else {
					openPropositionDialog("MyMapsContextMenu");
				}
				break;
		}
	}

	async _moveItemToFolder(itemData: any) {
		new MyMapsMoveItems({
			item: itemData,
			ids: [itemData.id],
			moveFolders: [{
				id: this._detailMapping.data.id,
				title: this._detailMapping.data.title,
			}],
			onSave: (folderId, folderTitle) => {
				this._moveDone();
			},
		}).open();
	}

	_moveDone() {
		Mapy.getComponent("places").listRefreshData();
		this.setMultipleMode(false);

		this._loadWithDelete();
	}

	/**
	 * Callback z popupu pro ulozeni/presunuti id do slozky.
	 *
	 * @param  {Object} data Callback data
	 */
	_mymapsAddPopupCb(data) {
		switch (data.name) {
			case "copy-done":
				let lastItem = this._lastAddPopupItem;

				// oznacime hvezdicku za pridanou
				if (lastItem && lastItem.id) {
					let star = this._dom.itemsList.querySelector(`li[data-id="${lastItem.data.id}"] .inner > span.star`);

					if (star) {
						star.classList.add("active");
					}
				}

				break;

			case "popup-close":
				if (data.createdFolders.length) {
					this._loadWithDelete();
				}
				break;
		}

		switch (data.type) {
			case "rename":
			case "move":
				this.load();
				break;
		}
	}

	/**
	 * Porovname li element s tim, co mame namapovano, pri shode vracime data.
	 *
	 * @param  {String} source folders/items
	 * @param  {Element} li Testovany li
	 * @return {Object}
	 */
	_getItemFromLi(source, li) {
		let items = source == this._dom.foldersList ? this._foldersMapping : this._itemsMapping;

		for (let i = 0; i < items.length; i++) {
			let item = items[i];

			if (item.el == li) {
				return item;
			}
		}

		return null;
	}

	/**
	 * Zobrazeni chybove hlasky.
	 *
	 * @param  {String} [msg] Hlaska
	 */
	_error(msg) {
		this._dom.error.textContent = msg || "";
	}

	/**
	 * Nastaveni modu hromadnych operaci.
	 *
	 * @param {Boolean} [state] Vlastni state jinak toggle
	 */
	setMultipleMode(state) {
		this._multipleMode = typeof state === "boolean" ? state : !this._multipleMode;

		// odskrtneme
		this._itemsMapping.forEach(i => {
			i.itemObject.data.checkbox.checked = false;
		});

		if (!this._multipleMode) {
			this._dom.multipleSwitch.checked = false;
		} else {
			Mapy.getComponent("places").detailLock = true;
			this._logger.log("click", { text: "Hromadné akce" });
		}

		this._error("");

		// pouze u itemu
		this._dom.container.classList[this._multipleMode ? "add" : "remove"]("edit-mode");
		this._dom.makeFolderCover.classList[this._multipleMode || this._opts.isDetail ? "add" : "remove"]("hide");
		this._sendSignal(this._multipleMode ? "multiple-mode-open" : "multiple-mode-close");

		this._checkedAll = false;
		this._updateSelectCount();
		this._updateVisited();

		this._scrollMultipleLine();
	}

	/**
	 * Ziskani vybranych itemu pri hromadnych operacich.
	 *
	 * @return {Array}
	 */
	_getSelectedItems() {
		let selected = [];

		if (this._multipleMode) {
			// zatim jenom itemy dle grafiky
			this._itemsMapping.forEach(i => {
				if (i.itemObject.data.checkbox.checked) {
					selected.push(i);
				}
			});
		}

		return selected;
	}

	/**
	 * Po novem nacteni listu aktualizujeme markery.
	 */
	_setMarkers() {
		makeEvent("places-marker-rewrite", this);
	}

	/**
	 * Vytvoreni markeru z dat.
	 *
	 * {Object} item Interni struktura, ktera obsahuje el, data...
	 * @return {SceneMarker}
	 */
	_createMarker(item) {
		let coords = Scene.coordsFromWGS84(item.data.mark.lon, item.data.mark.lat);
		let showLabel = CONFIG.inFrame && !Scene.isM3dActive() && ((this._opts.owner.showLabel === 1 && item.data.usertitle) || (this._opts.owner.showLabel === 2 && (item.data.usertitle || item.data.title)));
		let markerType = showLabel ? Scene.VISUAL.MARKER_WINDY.LITTLE : Scene.VISUAL.MARKER_WINDY.SMALL;

		// pokud je jen jeden item ve slozce a neni zapnute zobrazeni titulku, tak bude velky marker
		if (CONFIG.inFrame && !showLabel && this._itemsMapping.length == 1) {
			markerType = Scene.VISUAL.MARKER_WINDY.BIG;
		}

		let opts = {
			type: markerType,
			m3dData: {
				type: "places",
				click: () => {
					this._openDetail(item);
				},
				enter: () => {
					//if (this._activeDetail) return;

					this.highlightItem(item);
					this.highlightMarker(item);
				},
				leave: () => {
					//if (this._activeDetail) return;

					this.highlightItem();
					this.highlightMarker();
				}
			}
		};

		if (item.imageData.img && !showLabel) {
			let typeId = item.data.poi_type_id;
			let typeIcon = getIcon(typeId, { scale: 1 });
			let srcset = "";

			if (typeIcon) {
				let typeIcon2x = getIcon(typeId, { scale: 2 });

				if (typeIcon2x) {
					srcset = typeIcon + " 1x" + (typeIcon2x ? ", " + typeIcon2x + " 2x" : "");
				}
			}

			opts.icon = typeIcon || undefined;
			opts.srcset = srcset || undefined;
		}

		if (!opts.icon && !showLabel) {
			let iconCover = node("span", { className: "mymap-svg-layer" });
			iconCover.appendChild(icon(item.imageData.svgName || "star-line"));
			opts.elm = iconCover;
			opts.m3dData.svg = item.imageData.svgName;
		}

		let marker = Scene.createMarkerMapyWindy(coords, null, opts);
		marker.addEventListener("click", () => {
			this._openDetail(item);
		});
		marker.addEventListener("mouseenter", () => {
			this.highlightItem(item);
			this.highlightMarker(item);
		});
		marker.addEventListener("mouseleave", () => {
			this.highlightItem();
			this.highlightMarker();
		});

		if (showLabel) {
			marker.setLabel(item.data.usertitle || item.data.title);
		}

		item.marker = marker;

		return marker;
	}

	/**
	 * Otevreni detailu, switch podle typu.
	 *
	 * @param {Object} item Interni struktura, ktera obsahuje el, data...
	 */
	_openDetail(item) {
		// detail složky zvlast, jinak detaily na primo
		if (item.isFolder) {
			Mapy.getComponent("places").state = {
				mid: item.data.id,
				folderTitle: item.data.title,
				fromList: true,
				keepData: true
			};
			Mapy.getComponent("history").save();
		}
		else {
			this._openDetailRequest(item.data);
		}
	}

	/**
	 * Data z requestu pro detail liku.
	 *
	 * @param  {Object} data Like.detail
	 */
	_openDetailRequest(data, replace = false) {
		let History = Mapy.getComponent("history");

		if (CONFIG.inFrame) {
			let state = History.state;

			iframeAnalyticsLog({
				type: "click-back",
				referrer: document.referrer,
				form: "other",
			});
			window.open(`${CONFIG.mapyURL}/${state.mapset}?dim=${data.id}`);

		} else {
			const Dimcurator = Mapy.getComponent("dimcurator");
			const myMaps = Mapy.getComponent("mymaps");
			const { longitude, latitude, zoom } = store.getState().map;

			// pri replace url chceme smazat data pro prechod zpet
			if (replace) {
				Mapy.getComponent("places").state = {};
			}

			Dimcurator.setState({
				dim: data.id,
				backTitle: _("back"),
				backAction: function() {
					if (data.parent_id) {
						Mapy.getComponent("places").state = { mid: data.parent_id };
					}

					switch (data.type) {
						case "path":
						case "measure":
							Mapy.getComponent("path").deactivate();
							break;

						case "entity":
						case "point":
							store.dispatch(unsetDetail());
							break;

						case "link":
							if (data.linktype === "track") {
								Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("places"), true);
							}
							break;
					}

					Mapy.getComponent("dimcurator").setState();
					store.dispatch(setCoordinates({
						longitude,
						latitude,
						zoom,
						animate: false,
					}));
					Mapy.getComponent("history").save();
				},
			}).loadData().then(() => {
				this._lookup?.hideMarker(data);
				this._lookup?.hideGeometry(data);
				History.save(replace);
			}, () => {});

			myMaps.disableZoomToItems();
		}
	}

	/**
	 * Kliknuti na hvezdicku.
	 *
	 * @param  {Object} dataItem Interni struktura
	 */
	_starClick(dataItem) {
		let data = dataItem.data;
		const folderData = getFolderData();

		this._lastAddPopupItem = dataItem;
		new MyMapsMapyBoxItem({
			isPremiumUser: isPremiumNoteUser(),
			noteVersion: getNoteVersion(),
			createData: getCreateLikeData({
				id: data.id,
				title: data.title,
				description: data.description || "",
				type: data.type,
				actualFolderId: this._folderId,
				..."linktype" in data ? { linktype: data.linktype } : {},
				// eslint-disable-next-line camelcase
				..."user_time" in data ? { user_time: data.user_time } : {},
			}, "copy"),
			mode: "copy",
			...folderData
				? {
					folder: folderData,
				}
				: {},
			onSave: ({ likeData: newLikeData }) => {
				mapyboxAnalyticsSave({
					type: getMapyboxItemAnalyticsType(data),
					note: !!newLikeData.description,
					visited: newLikeData.visited,
				});
			}
		}).open();
	}

	/**
	 * Vlozeni loaderu
	 */
	_appendLoader() {
		this._dom.loaderCont.classList.add("active");
		this._dom.loaderCont.appendChild(this._dom.loader);
		this._dom.emptyLists.classList.add("hide");
	}

	/**
	 * Odstraneni loaderu.
	 */
	_removeLoader() {
		this._dom.loader.remove();
		this._dom.loaderCont.classList.remove("active");
	}

	/**
	 * Load novych dat se smazanim tech starych.
	 */
	_loadWithDelete() {
		this._cleanLists();
		this._setHeights();
		this.load();
		//this._lookup?.lookup();
	}

	/**
	 * Notifikace.
	 *
	 * @param  {String|Element} content Obsah zpravy
	 * @param  {Boolean} [isError] Jedna se o chybu?
	 */
	_notification(content, isError) {
		Notifications.notify({
			content,
			type: isError ? NOTIFICATIONS_TYPE.ERROR : NOTIFICATIONS_TYPE.SUCCESS
		});
	}

	/**
	 * pro akci v ramci og obrazku
	 */
	zoomToItems() {
		if (this._folderBBox.length && typeof this._folderBBox[0] === "number") {
			let c1 = Scene.coordsFromWGS84(this._folderBBox[0], this._folderBBox[1]);
			let c2 = Scene.coordsFromWGS84(this._folderBBox[2], this._folderBBox[3]);

			let centerZoom = Scene.computeCenterZoom([c1, c2], true);
			const [longitude, latitude] = centerZoom[0].toWGS84();

			store.dispatch(setCoordinates({
				longitude,
				latitude,
				...centerZoom[1] == Infinity ? {} : { zoom: centerZoom[1] },
				animate: true,
			}));
			Mapy.getComponent("history").save();
		}
	}

	_setHeights() {
		this._dom.itemsList.style.height = (Array.from(this._dom.itemsList.children).filter(i => !i.classList.contains("placeholder")).length * 68) + "px";
		this._dom.foldersList.style.height = (Array.from(this._dom.foldersList.children).filter(i => !i.classList.contains("placeholder")).length * 68) + "px";
	}

	_readyContextMenu(item, isDetail, activator) {
		const contextMenu = new ContextMenu({
			anchor: activator,
			position: "bottom-end",
			offset: 8,
		});

		const isTrackLink = item.data.type === "link" && item.data.linktype === "track";
		const isFolder = item.data.type === "folder";

		(item.data.foreign
			? ["add-to-folder"]
			: [
				...!(isFolder && isDetail) ? ["share"] : [],
				...isFolder ? ["always-on-map"] : [],
				...item.data.type === "entity" || item.data.type === "point" ? ["navigate"] : [],
				...isFolder ? ["duplicate"] : [],
				"edit",
				...["folder", "route", "set", "measure", "path"].includes(item.data.type) || isTrackLink ? ["download"] : [],
				...isFolder ? ["import"] : isTrackLink ? ["link-to-another-folder"] : ["save-as-new", "move-to-folder"],
				...isFolder && isDetail ? ["multiple"] : [],
				...isTrackLink ? ["activity-remove", "delete-from-all"] : ["delete"],
			]
		).forEach(name => {
			if (name === "always-on-map") {
				contextMenu.container.appendChild(new ContextMenuItem({
					icon: createSDSIcon({ symbol: item.data.always_on_map ? VISIBILITY_OFF_24 : VISIBILITY_24 }),
					text: item.data.always_on_map ? _("mymap.contextMenu.disableAoM") : _("mymap.contextMenu.enableAoM"),
					...isPremiumNoteUser() ? {} : { rightIcon: createPremiumIcon() },
					onClick: event => {
						event.stopPropagation();
						contextMenu.close();
						contextMenu.destroy();
						this._contextMenuCb(name, item);
					},
				}).container);
			} else {
				contextMenu.container.appendChild(new ContextMenuItem({
					icon: contextmenuGetIcon(name),
					text: contextmenuGetTitle(name),
					onClick: event => {
						event.stopPropagation();
						contextMenu.close();
						contextMenu.destroy();
						this._contextMenuCb(name, item);
					},
					destructive: ["delete", "delete-from-all"].includes(name),
				}).container);
			}
		});

		item.contextMenu = contextMenu;
	}

	/**
	 * Poslani signalu - otevreni, zavreni editace, nastaveni slozky.
	 *
	 * @param  {String} name Nazev signalu
	 * @param  {Object} data Vlastni data
	 */
	_sendSignal(name, data) {
		if (typeof this._opts.cb === "function") {
			this._opts.cb(Object.assign({
				name
			}, data));
		}
	}

	_resize() {
		let mobile = Mapy.Util.isSmallResolution() || Mapy.Util.isTouchDevice();

		this._sortableFolders.options = {
			scrollArea: 20,
			handle: mobile ? "li .points" : "li",
			touchHandle: "li .points"
		};
		this._sortableItems.options = {
			scrollArea: 10,
			handle: mobile ? "li .points" : "li",
			touchHandle: "li .points"
		};
	}

	/**
	 * Vybere všechny prvky při hromadné akci
	 * @param {Bool} check Zškrtnout vše?
	 */
	_selectAll(check) {
		if (this._multipleMode) {
			this._itemsMapping.forEach(i => {
				i.itemObject.data.checkbox.checked = check;
			});

			this._checkedAll = check;
			this._updateSelectCount();
		}
	}

	/**
	 * Zakazeni interakce nad vrstvou.
	 */
	_disableInteraction() {
		this._opts.layer?.disableInteraction();
		this._lookup?.disableInteraction();

		this._activeDetail = true;
	}

	/**
	 * Povoleni interakce nad vrstvou.
	 */
	_enableInteraction() {
		this._opts.layer?.enableInteraction();
		this._lookup?.enableInteraction(true);

		this._activeDetail = false;
	}

	_printPage() {
		if (!this._active) { return; }

		let printPromise = Mapy.Util.createPrintPromise();
		Mapy.getComponent("print").addDepends(printPromise);

		// hlavicka
		let header = node("div", { className: "map-title" }, _("mymap.title"));
		this._dom.container.insertBefore(header, this._dom.container.firstChild);

		let imagePromises = [];

		this._foldersMapping.forEach(folder => {

			let imgPromise = new Promise(resolve => {
				let image = node("img", { className: "print-folder-image" });
				image.addEventListener("load", () => {
					resolve();
				});
				image.addEventListener("error", () => {
					resolve();
				});
				image.src = folder.img ? Mapy.CDN.setSize(folder.img, Mapy.CDN.SIZE_667_500) : List.PLACEHOLDER_URL;
				folder.elData.imageCover.appendChild(image);
			});
			imagePromises.push(imgPromise);
		});

		this._userNote?.print();
		this._text?.print();

		Promise.all(imagePromises).then(() => {
			printPromise.resolve();
		}, () => {});
	}

	_printDone() {
		if (!this._active) { return; }

		Array.from(this._dom.container.querySelectorAll(".map-title")).forEach(el => {
			el.remove();
		});

		Array.from(this._dom.container.querySelectorAll(".print-folder-image")).forEach(el => {
			el.remove();
		});
	}

	_show3dRoutes() {
		if (Scene.isM3dActive()) {
			let lines = [];

			this._itemsMapping.forEach(i => {
				let data = i.data;

				if ((data.type == "route" || data.type == "track") && data.data && data.data.geometry) {
					let geometry = Scene.stringToCoords(data.data.geometry);
					lines.push(geometry.map(i => i.toWGS84()));
				}
			});

			if (lines.length) {
				this._freeLayer = Scene.createLayerFree("mymaps", lines, {
					lineColor: [255, 0, 0, 150],
					lineWidth: 5,
					lineOffset: [-0.19, 0, 0],
					outlineWidth: 0,
					outlineOffset: [-0.19, 0, 0]
				});
				Scene.addLayer(this._freeLayer);
			}
		}
	}

	_removeFreeLayers() {
		if (this._freeLayer) {
			Scene.removeLayer(this._freeLayer);
			this._freeLayer.destroy();
			this._freeLayer = null;
		}
	}

	_checkLoadNext() {
		if (Mapy.getComponent("places").isActive && Mapy.active[0] == Mapy.getComponent("mymaps")) {
			let scrollNode = Mapy.getComponent("layout").getScrollNode();
			let h = scrollNode.offsetHeight;
			let listH = this._dom.container.offsetHeight;

			if (listH - (h + scrollNode.scrollTop) < 85) {
				this._loadNextPage().then(data => {
					if (data?.count) {
						this._checkLoadNext();
					} else {
						this._itemsCount = this._foldersMapping.length + this._itemsMapping.length;
					}
				}, () => {});
			}
		}
	}

	_cleanLists() {
		Mapy.Util.clear(this._dom.foldersList);
		Mapy.Util.clear(this._dom.itemsList);
		this._updateScrollUIElems();
		this._clearFilter();
		this._dom.emptyFilterInfo.remove();
	}

	_updateCacheWithDescription() {
		if (this._itemsCache.toGet.length) {
			description(this._itemsCache.toGet, { lang: [CONFIG.defaultLang] }).then(r => {
				r.poi.forEach(poi => {
					let multiTitle = poi.multiTitle || null;
					let desc = poi.typeName || (multiTitle ? multiTitle.filter(t => t.trim() != "").join(", ") : "");

					(this._itemsCache.cache[`${poi.source}${poi.id}`] || []).forEach(i => {
						i.description = desc;
						i.item.itemObject.subtitle = desc;
					});
				});
			}, () => {});
		}
	}

	setSEO() {
		Mapy.SEO.set((this._opts.isDetail ? this._detailMapping?.data.title + " - " : "") + _("mymap.switcher.saved"));
	}

	_scroll() {
		this._multipleMode && this._scrollMultipleLine();
		(this._loadFolderItems && !this._loadNextPageLock) && this._checkLoadNext();
	}

	_setLoadFolderItems() {
		this._loadFolderItems = this._loadedItems < this._itemsCount;
	}

	_scrollMultipleLine() {
		let scrollNode = Mapy.getComponent("layout").getScrollNode();

		if (scrollNode.scrollTop > 0) {
			this._dom.listHeader.classList.add("scrolled");
		} else {
			this._dom.listHeader.classList.remove("scrolled");
		}
	}

	_updateSelectCount() {
		const items = this._getSelectedItems();
		const isAll = this._itemsMapping.length === items.length;

		this._dom.selectCount.textContent = items.length;

		if (isAll && !this._dom.multipleSwitch.checked) {
			this._dom.multipleSwitch.checked = true;
		} else if (!isAll && this._dom.multipleSwitch.checked) {
			this._dom.multipleSwitch.checked = false;
		}
	}

	_updateVisited() {
		if (this._multipleVisited) {
			let count = 0;
			let checked = 0;

			for (const item of this._itemsMapping) {
				if (item.itemObject?.hasVisited) {
					count++;

					if (item.itemObject.isVisitedCheck) {
						checked++;
					}
				}
			}

			this._multipleVisited.checked = checked === count && count > 0;
		}
	}

	async _exportFolder(data: any) {
		let folderData = {
			...data,
			items: [],
		};

		try {
			const folderListData = await Mapy.ProviderMapyBox.folderList(data.id);

			folderData = folderListData.folder;

		} catch (exc) {
			getMapyboxExcError(exc);
		}

		exportMultiroute(folderData);
	}

	async _editTrack(data: IMapyBoxItem) {
		try {
			const trackData = await Mapy.ProviderMapyBox.trackDetail(data.linkid).promise;

			new MyMapsEditActivity({
				isPremiumUser: isPremiumNoteUser(),
				noteVersion: getNoteVersion(),
				data: trackData.track,
				onSave: updData => {
					data.usertitle = updData.usertitle;
					data.title = updData.title;
					data.description = updData.description;

					this._moveDone();
					this._lookup.lookup();
				},
			}).open();
		} catch (exc) {
			getMapyboxExcError(exc);
		}
	}

	async _setAllVisited(newVisited: boolean) {
		const visitedIds = [];
		const visitedItems = [];

		for (const item of this._itemsMapping) {
			if (item.itemObject.hasVisited) {
				// zmena
				if (item.data.visited !== newVisited) {
					visitedIds.push(item.data.id);
					visitedItems.push(item);
				}
			}
		}

		const visitedState = await setMultipleVisited(visitedIds, newVisited);

		if (visitedState.error) {
			return false;
		}

		for (const item of visitedItems) {
			item.itemObject.visited = newVisited;
			item.data.visited = newVisited;
		}

		return true;
	}

	_updateMultipleVisited() {
		if (this._multipleVisited) {
			this._multipleVisited.container.remove();
		}

		this._multipleVisited = null;

		const isUserPremium = isPremiumNoteUser();

		if (isUserPremium && Mapy.CUS.mapybox?.visited) {
			let reqLock = false;

			this._multipleVisited = new MyMapsVisited({
				checked: false,
				clickable: true,
				onClick: async (target) => {
					if (reqLock) {
						return;
					}

					const newVisited = !target.checked;

					target.checked = newVisited;
					reqLock = true;

					const visitedState = await this._setAllVisited(newVisited);

					if (!visitedState) {
						target.checked = !newVisited;
					}

					reqLock = false;
				},
				tooltip: {
					checked: _("mymap.visited.unmarkAll"),
					unchecked: _("mymap.visited.markAll"),
				},
			})
			this._dom.controlsRight.append(this._multipleVisited.container);
		}
	}
}

List.PLACEHOLDER_URL = "/img/mymap/folder-placeholder-detail.png";
